<template>
    <div ref="articlecontainer">
        <div class="flex flex-col lg:w-2/3 items-stretch gap-md mb-lg lg:pr-xs">
            <div>
                <label class="font-semibold mb-xxs inline-block" for="search">Zoeken</label>

                <div class="relative">
                    <input
                        class="form__input py-[20px] pr-lg px-sm form__input--filled-dark placeholder:text-ellipsis"
                        v-model="params.search"
                        @input="searchImmediately"
                        id="search"
                        name="search"
                        placeholder="Vul hier een trefwoord in"
                        type="text"
                    />

                    <div class="absolute right-sm top-1/2 -translate-y-1/2 text-gray-600 hover:text-gray-400 cursor-pointer" @click.prevent="search">
                        <i class="fa-regular fa-search"></i>
                    </div>
                </div>
            </div>
            <div class="flex flex-wrap gap-sm items-center justify-start">
                <template v-for="item in categories">
                    <a
                        v-if="item.count > 0 && item.slug !== 'geen-onderdeel-van-een-categorie'"
                        href="#"
                        :key="item.id"
                        @click.prevent="filter(item.id)"
                        class="py-xxs px-xs text-xs uppercase hover:text-primary-400 hover:border-primary-400 text-gray-500 border transition-colors inline-flex border-gray-600 text-opacity-80 tracking-[2px] font-semibold cursor-pointer select-none"
                        :class="{
                            'bg-primary-400 !text-gray-800': active_categories.includes(item.id),
                        }"
                        v-html="item.name"
                    >
                    </a>
                </template>
            </div>
        </div>

        <div key="loading" class="flex justify-center" v-if="loading">
            <div class="aspect-[320/520] w-1/4 relative mb-sm sm:mb-md flex justify-center items-center">
                <i class="fa-regular fa-spinner-third h-[60px] w-auto animate-spin"></i>
            </div>
        </div>
        <div v-else-if="articles.length" class="grid grid-cols-12 gap-y-lg sm:gap-x-md md:gap-y-xl">
            <div v-for="(item, index) in articles" :key="item.id" class="col-span-12 xs:col-span-6 md:col-span-4 flex">
                <blogitem :content="item" />
            </div>

            <div class="col-span-12">
                <pagination :current-page="params.page" :total-pages="totalPages" @next-page="filter(null, params.page + 1)" @previous-page="filter(null, params.page - 1)" @go-to-page="(event) => filter(null, event.page)"> </pagination>
            </div>
        </div>
        <div key="empty" v-else>
            <p class="my-3xl text-center">Geen artikels gevonden. Probeer een andere zoekopdracht.</p>
        </div>
    </div>
</template>

<script>
import axios from 'axios';
import blogitem from './item';
import { debounce, cloneDeep } from 'lodash';
var scrollIntoView = require('scroll-into-view');
import translate from 'translate';
translate.key = process.env.MIX_GOOGLE_TRANSLATE_API_KEY;

export default {
    name: 'blogoverview',

    data() {
        return {
            params: {
                per_page: 9,
                page: 1,
                paginate: true,
                search: '',
                categories: [],
            },
            loading: false,
            articles: [],
            categories: [],
            active_categories: [],
            totalPages: 0,
        };
    },

    created() {
        let urlParams = new URLSearchParams(window.location.search);
        this.params.page = parseInt(urlParams.get('p') ?? 1);
        this.active_categories = urlParams.getAll('c');
        this.active_categories = this.active_categories.map((c) => parseInt(c));
        this.params.categories = this.active_categories;
        this.params.search = urlParams.get('s') ?? '';

        this.getArticleCategories();
        this.getArticles(false);
    },

    mounted() {
        this.$forceUpdate();
    },

    methods: {
        filter(id, page = null) {
            if (id) {
                if (this.active_categories.includes(id)) {
                    this.active_categories = this.active_categories.filter((el) => el !== id);
                } else {
                    this.active_categories.push(id);
                }

                this.params.categories = this.active_categories;
            }

            if (page) {
                this.params.page = page;
            } else {
                this.params.page = 1;
            }

            this.getArticles();
        },

        async getArticles(scroll = true) {
            this.loading = true;

            if (scroll) {
                scrollIntoView(this.$refs.articlecontainer);
            }

            let translatedParams = cloneDeep(this.params);
            if (this.params.search !== '' && document.documentElement.lang !== 'nl') {
                translatedParams.search = await translate(this.params.search, 'nl');
            }

            axios
                .get('/api/articles', { params: { ...translatedParams } })
                .then((response) => {
                    if (response.data.status === 200) {
                        this.articles = response.data.data.results;
                        this.totalPages = Math.ceil(parseInt(response.data.data.meta.total) / this.params.per_page);
                        this.setQueryParams();
                    } else {
                        this.articles = [];
                    }
                })
                .finally(() => (this.loading = false));
        },

        getArticleCategories() {
            axios.get('/api/categories', { params: { ...this.params } }).then((response) => {
                if (response.data.status === 200) {
                    this.categories = response.data.data.results;
                } else {
                    this.categories = [];
                }
            });
        },

        setQueryParams() {
            const searchParams = new URLSearchParams();

            if (this.params.page !== 1) {
                searchParams.set('p', this.params.page);
            }

            if (this.params.search && this.params.search !== '') {
                searchParams.set('s', this.params.search);
            }

            this.params.categories.forEach((ac) => {
                searchParams.append('c', ac);
            });

            let newRelativePathQuery = window.location.pathname;
            let hasKeys = false;

            for (const key of searchParams.keys()) {
                hasKeys = true;
            }

            if (hasKeys) {
                newRelativePathQuery += '?' + searchParams.toString();
            }
            history.pushState(null, '', newRelativePathQuery);
        },

        search() {
            this.params.page = 1;
            this.getArticles();
        },

        searchImmediately: debounce(function () {
            this.search();
        }, 500),
    },

    components: {
        blogitem,
    },
};
</script>
